import { SeeqNames } from '@seeqdev/constants';
import { fcCapsuleSet, fcScalar, fcSeries } from '@seeqdev/icons/seeq';
import type { IconDefinition } from '@seeqdev/icons';

const packageName = SeeqNames.MlService.SelfOrganizingMap.Connection.UdfPackage;
const udfName = SeeqNames.MlService.SelfOrganizingMap.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_GRID_DIMENSION = null;
export const DEFAULT_NUM_ITERATIONS = null;
export const DEFAULT_LEARNING_RATE = 0.5;
export const DEFAULT_SIGMA = 1.0;
export const DEFAULT_ANOMALY_THRESHOLD = 95;
export const DEFAULT_RANDOM_ORDER = false;
export const QUANTIZATION_OUTPUT = 'quantizationOutput';
export const MAX_INPUT_SIGNALS = 50;

export const INPUT_NAMES = {
  gridDimensionInput: 'gridDimensionInput',
  randomOrderInput: 'randomOrderInput',
  learningRateInput: 'learningRateInput',
  sigmaInput: 'sigmaInput',
  anomalyThresholdInput: 'anomalyThresholdInput',
  numIterationsInput: 'numIterationsInput',
  startTimeInput: 'startTimeInput',
  endTimeInput: 'endTimeInput',
  signalInput: 'signalInput',
  restrictOutputToConditionInput: 'restrictOutputToConditionInput',
  trainWithinConditionInput: 'trainWithinConditionInput',
  mergeCapsuleDurationInput: 'mergeCapsuleDurationInput',
  minCapsuleDurationInput: 'minCapsuleDurationInput',
  scaleInputsInput: 'scaleInputsInput',
};

export const OUTPUT_TRANSLATION_KEYS: Record<string, { label: string; icon: IconDefinition }> = {
  anomalyOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.ANOMALY_CONDITION',
    icon: fcCapsuleSet,
  },
  quantizationErrorSignalOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.QUANTIZATION_ERROR_SIGNAL',
    icon: fcSeries,
  },
  averageQuantizationErrorOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.AVERAGE_QUANTIZATION_ERROR',
    icon: fcScalar,
  },
  anomalyDetectionErrorThresholdOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.ANOMALY_DETECTION_ERROR_THRESHOLD',
    icon: fcScalar,
  },
  modelInputPropertiesOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.MODEL_INPUT_PROPERTIES',
    icon: fcScalar,
  },
  trainingWindowConditionOutput: {
    label: 'INVESTIGATE_TOOLS.SELF_ORGANIZING_MAPS_V2.OUTPUTS.TRAINING_WINDOW_CONDITION',
    icon: fcCapsuleSet,
  },
};

export const DEFAULT_OUTPUTS: string[] = ['anomalyOutput', 'quantizationErrorSignalOutput'];

export const MODEL_NAME = SeeqNames.ModelNames.SelfOrganizingMap;
